import { Box, Typography } from "@mui/material";
import React, { useState, useEffect, useRef } from 'react';
import SeverityAlert from "../../../images/SeverityAlert.svg";
import Check from "../../../images/Checkbox.svg";
import CustomTableHeading from '../../CommonComponents/CustomTableHeading';
import CustomTableMetric from '../../CommonComponents/CustomTableMetric';
import CustomActionButton from "../../CommonComponents/CustomActionButton";
import "../../../cssfiles/homepage.css";
import CustomTextField from "../../CommonComponents/CustomTextField";
import CustomLabel from "../../CommonComponents/CustomLabel";
import CustomButton from "../../CommonComponents/CustomButton";
import CustomCheckbox from "../../CommonComponents/CustomCheckbox";
import CustomSelect from "../../CommonComponents/CustomSelect";
import CustomMultiSelect from "../../CommonComponents/CustomMultiSelect";
import CustomDialogBox from "../../CommonComponents/CustomDialogBox.jsx";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Snackbar from '@mui/material/Snackbar';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Alert from '@mui/material/Alert';
import {  Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import CustomCancelButton from "../../CommonComponents/CustomCancelButton";
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import {
  Menu,
  MenuItem,
} from '@mui/material';
import { getAlarmConfig, deleteAlarmConfig } from '../../../Restclient/datacollection';
import Dialogbox from "../../CommonComponents/Dialogbox";
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useSelector } from "react-redux";
import AlertRulesConfig from "./AlertRulesConfig";
import AlertRulesEdit from "./AlertRulesEdit";
import LK_Add from '../../../images/LK_Add.js';
import LK_Edit from "../../../images/LK_Edit";
import LK_Delete from "../../../images/LK_Delete";
import LK_Clone from "../../../images/LK_Clone";

export default function AlertConfiguration() {
    
    //To set setting unique alert condition which is being edited
    const [uniquealarmcondition, setUniqueAlarmCondition] = useState([]);
    //to set edit rules boolean to true to goto the edit page
    const [alarmrulesedit, setAlarmRulesEdit] = useState(false)
    //to set create rules boolean to true to goto the create page
    const [alarmrules, setAlarmRules] = useState(false)
    //to set clones rules 
    const [alarmrulesclone, setAlarmRulesClone] = useState({
        state:false,
        alarm_value:''
    })
    //to check if cloned rule is copied-(Note this is not used)
    const [isCopied, setIsCopied] = useState(false);
    //Theme
    const themechange = useSelector((state) => state.themedata.theme)
    //to handle open condition for dialog box asking confirmation to clone an alert rule
    const [open, setOpen] = useState(false);
    //boolean variable which is true or false depending upon cloned rule exists or not
    const [clonedRuleExists , setClonedRuleExists] = useState(false);
    //state variable to hold list of configured alert rules
    const [configrules, setConfigRules] = useState([]);
    //State variable to hold selected alert rule to delete
    const [selectedDeleteAlarm,setSelectedDeleteAlarm]= useState({});
    const [deletedSuccess, setDeletedSuccess] = useState(false);
    const [deletedSuccessMsg, setDeletedSuccessMsg] = useState("");
    const [deletedError, setDeletedError] = useState(false);
    const [deletedErrorMsg, setDeletedErrorMsg] = useState("");
    //to handle open condition for dialog box asking confirmation to delete an alert rule
    const [openDialog,setOpenDialog]= useState(false);
    //user details of logged in user
    const userdetails = useSelector((state) => state.logindata.userdetails)
    //tagdetails
    //const [tagdetails, setTagDetails] = useState('');
    //const [devicedetails, setDeviceDetails] = useState('');
    //devicedetails
    const tagdetails = useSelector((state) => state.mainpagedata.tagdetailsobject)
    const devicedetails = useSelector((state) => state.mainpagedata.devicedetailsobject)
    
    //callback function to filter alarms which have same project id as the project id of logged in user
    //optimizing it 
    const selectedprojectname = useSelector((state) => state.mainpagedata.selectedprojectname)
    const projectfilteralarms = (alarm) => {return(alarm.projectid == userdetails.Projectid)}
    const [errMessage, setErrMessage] = useState('');
    const [errExists, setErrExists] = useState(false);
    const [errExistsOpenDialog, setErrExistsOpenDialog] = useState(false);

    //callback function to set state variable of configrules to hold alerts meant for logged in project user
    const alarmconfigcallback = (res,status) => {
        if(status == 200){
            var currentconfigrules = res?.data?.data;
            if (currentconfigrules && Array.isArray(currentconfigrules)) {
                
                const newCurrentConfigRules = currentconfigrules.map((rule) => {
                    if (!rule || !rule.conditions) {
                        console.error("Invalid rule or conditions:", rule);
                        return null; // Skip invalid rules
                    }
                    var currentconditions = rule.conditions.map((currentcondition)=>{
                        var currentsetpoint1 = 0;
                        var currentsetpoint2 = 0;
                        if((currentcondition.type=="Conditional") && ( (currentcondition.condition=="<") || (currentcondition.condition=="<="))){
                            currentsetpoint1 = currentcondition.value.alarm_condition_upper;
                            currentsetpoint2 = "";
                        }else if((currentcondition.type=="Conditional") && ( (currentcondition.condition==">") || (currentcondition.condition==">="))){
                            currentsetpoint1 = currentcondition.value.alarm_condition_lower;
                            currentsetpoint2 = "";
                        }else if((currentcondition.type=="Ranges") && ( (currentcondition.condition==">...<") || (currentcondition.condition==">=...<=") || (currentcondition.condition=="<...>") || (currentcondition.condition=="<=...>="))){
                            currentsetpoint1 = currentcondition.value.alarm_condition_lower;
                            currentsetpoint2 = currentcondition.value.alarm_condition_upper;
                        }else if(currentcondition.type == "Equal"){
                            currentsetpoint1 = currentcondition.value.alarm_condition_upper;
                            currentsetpoint2 = "";
                        }
            
                        return {
                            ...currentcondition,
                            setpoint1:currentsetpoint1,
                            setpoint2:currentsetpoint2,
                        }
            
                    })
        
                return {
                    ...rule,
                    conditions:currentconditions,
                    DeviceID: tagdetails[rule?.TagID]?.DeviceID,
                    Alias: tagdetails[rule?.TagID]?.Alias,
                    TagUnit: tagdetails[rule?.TagID]?.Unit,
                    TagDataType: tagdetails[rule?.TagID]?.DataType,
                    DeviceName: devicedetails[tagdetails[rule?.TagID]?.DeviceID]?.Name
                };
                });
                setConfigRules(newCurrentConfigRules);
                setErrExists(false)
            }else{
                console.error("currentconfigrules is not valid or empty.");
                setErrMessage('Could not fetch Alert Rules');
                setErrExists(true);
                setErrExistsOpenDialog(true);
            }
        }else if((status == 500) || (status == 'error')){
            setErrMessage('Could not fetch Alert Rules');
            setErrExists(true)
            setErrExistsOpenDialog(true)
        }
        
    };

    function handlesetDeletedSuccess() {
        setDeletedSuccess(false);
    }

    function handlesetDeletedError() {
        setDeletedError(false);
    }

    function handleErrorExistsConfirm(){
        setErrExistsOpenDialog(false)
    }
    //setting alarmrules boolean to goto create page when user has chosen -create alert rule button 
    function handleCreateChange(){
        setAlarmRules(true);
    }

    //To handle Editing Alert Rules
    //-To set setting unique alert condition which is being edited
    //-to set edit rules boolean to true to goto the edit page
    function handleEdit(alarm_rule){
        setUniqueAlarmCondition({alarmrule:alarm_rule})
        setAlarmRulesEdit(true)
    }

    //callback to re-render configured alerts after deletion of an alert rule
    const deletecallback = (datadeleted) => {
        // Check for success/failure and show feedback
        if (datadeleted.status === 'success' && datadeleted.code === 200) {
            // Optionally show a success notification
            // showNotification('Alert rule deleted successfully', 'success');
            setDeletedSuccess(true);
            setDeletedSuccessMsg(datadeleted.message)
            if (userdetails.Projectid == 'All') {
                getAlarmConfig(selectedprojectname, userdetails.Projectlist, alarmconfigcallback);
            } else {
                getAlarmConfig(userdetails.Projectid, userdetails.Projectlist, alarmconfigcallback);
            }
        } else {
            // Optionally show an error notification
            // showNotification(datadeleted.message || 'Failed to delete alert rule', 'error');
            console.error('Delete failed:', datadeleted.message, datadeleted.error);
            setDeletedError(true);
            setDeletedErrorMsg(datadeleted.message)
            // Optionally, you can still refresh or handle UI state here if needed
        }
    };

    //To handle deletion of alert rule- called on the click of delete icon against an alert rule
    const handleDelete = (alarm_rule) => { 
        //to set selected alert rule to delete
        setSelectedDeleteAlarm(alarm_rule);
        //to set to true- open condition for dialog box asking confirmation to delete an alert rule
        setOpenDialog(true);
    }

    //after receving confirmation from dialogbox-for dialog box asking confirmation to delete an alert rule, we can proceed to delete alert rule and close confirmation dialog box
    const handleDeleteConfirm = () => {
        if(selectedDeleteAlarm) {
            if(userdetails.Projectid == 'All'){
                deleteAlarmConfig(deletecallback ,userdetails.Userid,selectedprojectname,selectedDeleteAlarm);
            }else{
                deleteAlarmConfig(deletecallback ,userdetails.Userid,userdetails.Projectid,selectedDeleteAlarm);
            }  
            
            setOpenDialog(false);
        }
    }
    
    //function to handle closing of delete confirmation dialog
    function handleCloseDialog(){
        setOpenDialog(false);
       
    }
    
    //Closing dialog confirmation for cloning of ule
    const handleClose = () => {
        setOpen(false);
    }

//     const postalarmconfigcallback = (res) => {
//         console.log("postalarmconfigcallback for cloned rule",res.data.data.state)
//         if(res.data.data.state == true){
//             setClonedRuleExists(true)
//         }else{
//             getAlarmConfig(alarmconfigcallback);
//         }
//     }

//     function handleCloseClonedRuleExists(){
//         setClonedRuleExists(false);
//     }

//     function handleClonedRuleExists(){
//         setClonedRuleExists(false);
//     }

//     function generateCustomUUID() { 
//         return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) { 
//             const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8); 
//             return v.toString(16); 
//         }); 
//     } 

//    // console.log(generateCustomUUID()); 
//     function handleClone(alarm_rule){
//         console.log("handleClone-alarm_rule",alarm_rule)


//         var cloned_rule = { ...alarm_rule, 
//                             id:generateCustomUUID(),
//                             alarm_rule_name:"cloned"+alarm_rule.alarm_rule_name, 
//                             device_id:"cloned"+alarm_rule.device_id, 
//                             tagid:"cloned"+alarm_rule.tagid,
//                             selected_tag_name:{
//                                 tagname: "cloned" + alarm_rule.selected_tag_name.tagname,
//                                 tagunit: "cloned" + alarm_rule.selected_tag_name.tagunit,
//                                 tagdatatype: "cloned" + alarm_rule.selected_tag_name.tagdatatype,
//                                 std_tagname: "cloned" + alarm_rule.selected_tag_name.std_tagname
//                             }
//                         }
//         console.log("cloned_rule",cloned_rule)
//         //postalarmconfig(cloned_rule,postalarmconfigcallback);
//         setAlarmRulesClone(cloned_rule);
//         /*const textToCopy = `Hi`;
//         navigator.clipboard.writeText(textToCopy).then(() => {
//             setIsCopied(true); 
//             setTimeout(() => setIsCopied(false), 2000);
//         });
//         */
//         setOpen(true);
//     }

    //useeffect to re-render alert config in case of creation or editing , deleting or cloning alert rules-(deleting , cloning to be checked)

    // const getTagDetailsInformationProjectwisecallback = (res) => {
    //     console.log("getTagDetailsInformationProjectwisecallback in here-",res?.data?.data)
    //     setTagDetails(res?.data?.data)
    //     getDeviceDetailsInformationProjectwise(userdetails.Projectid,getDeviceDetailsInformationProjectwisecallback)
        
    // }

    // const getDeviceDetailsInformationProjectwisecallback = (res) => {
    //     console.log("getDeviceDetailsInformationProjectwisecallback in here-",res?.data?.data)
    //     setDeviceDetails(res?.data?.data)
    //     getAlarmConfig(userdetails.Projectid, alarmconfigcallback);  
        
    // }

    // useEffect(()=>{
    //     getTagDetailsInformationProjectwise(userdetails.Projectid,getTagDetailsInformationProjectwisecallback)
    // },[])
    
    useEffect(()=>{ 
        if(selectedprojectname != undefined || selectedprojectname != null || selectedprojectname != ''){
            if(userdetails && userdetails.Projectid && userdetails.Projectlist){
                getAlarmConfig(selectedprojectname, userdetails.Projectlist, alarmconfigcallback);
            }
        }

        // console.log("RECAHED HERE TO RENDER ALARM CONFIG CALLBACK")
        // //getTagDetailsInformationProjectwise(userdetails.Projectid,getTagDetailsInformationProjectwisecallback)
        // if(userdetails.Projectid == 'All'){
            
        // }else{
        //     getAlarmConfig(userdetails.Projectid, alarmconfigcallback);
        // }
            
    },[alarmrules,alarmrulesedit,selectedprojectname])

    return(
        <>
            {errExists &&
            <>
                <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px",marginTop:"6px", textAlign:"left"}}>{errMessage}</Typography>
                <CustomDialogBox dialogTitle={"Configuration Not Found"} dialogText={"Alerts Configuration Not Found"} openDialog={errExistsOpenDialog} handleCloseDialog={handleErrorExistsConfirm} handleConfirmDialog={handleErrorExistsConfirm} confirmText={"OK"} cancelText={"Cancel"}/>
            </>}
            {!errExists &&
            <div style={{backgroundColor: 'var(--SecondaryBackground)'}}>  
            {
                (alarmrules == false && alarmrulesedit==false )
                ?
                <div style={{width:'100%'}}>  
                <div style={{display:"flex", marginTop:0, paddingTop:0}}>
                    <div style={{flexGrow: 1}}></div>
                    <Button sx={{fontSize:"16px",fontFamily:"Roboto",textTransform:'capitalize', marginTop:"5px", marginRight:"5px",backgroundColor:"var(--SecondaryBackground)", borderRadius:"20px", width:"70px",paddingTop:"3px",paddingBottom:"3px",boxShadow: "none"}} variant="text" onClick={handleCreateChange} disableTouchRipple elevation={0}><LK_Add color={"#005C8E"} width={"45px"} height={"45px"}/></Button>
                </div>
                <div style={{width:'100%'}}>
                    <TableContainer component={Paper} sx={{ width: '100%', height:"100%",paddingLeft:'0px',backgroundColor:'var(--secondary-backgroundLK)',paddingRight:'0px' }} elevation={0}>
                        <Table sx={{ width: '100%' }} size="large" >
                            <TableHead>
                                <TableRow sx={{border:"0px"}}>
                                    <TableCell align="left" sx={{ fontSize:"12px",fontWeight:400,color:"var(--grey-variation-tableLK)"}}><CustomTableHeading children={'Alert'} /></TableCell>
                                    <TableCell align="left" sx={{ fontSize:"12px",fontWeight:400,color:"var(--grey-variation-tableLK)"}}><CustomTableHeading children={'Tagname'} /></TableCell>
                                    <TableCell align="left" sx={{ fontSize:"12px",fontWeight:400,color:"var(--grey-variation-tableLK)",paddingLeft:4.5}}><CustomTableHeading children={'Edit'} /></TableCell>
                                    <TableCell align="left" sx={{ fontSize:"12px",fontWeight:400,color:"var(--grey-variation-tableLK)",paddingLeft:4.5}}><CustomTableHeading children={'Delete'} /></TableCell>
                                    {/*<TableCell align="left" sx={{ fontSize:"12px",fontWeight:400,color:"var(--grey-variation-tableLK)",paddingLeft:4.5}}><CustomTableHeading children={'Clone'} /></TableCell>*/}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {/*((tagDeviceMappings[currentalarmrule.tagid]?.tagInfo != undefined ) && (tagDeviceMappings[currentalarmrule.tagid]?.deviceInfo != undefined ))?tagDeviceMappings[currentalarmrule.tagid].deviceInfo?.Name+" : "+tagDeviceMappings[currentalarmrule.tagid].tagInfo:"" */}
                                {configrules.map((currentalarmrule, index) => (
                                    
                                    <TableRow key={currentalarmrule.id} sx={{'&:last-child td, &:last-child th': { border: 0 },height:"9px",'& > *': { borderBottom: "1px solid var(--table-boarder-line)" } }}>
                                        <TableCell component="th" scope="row" sx={{ fontSize:"12px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)',paddingTop:"5px",paddingBottom:"5px"}}><CustomTableMetric children={ (currentalarmrule && Object.keys(currentalarmrule).length !==0 && currentalarmrule.hasOwnProperty('Alert_rule_name') && currentalarmrule.Alert_rule_name != undefined)? currentalarmrule.Alert_rule_name : 'Alert Rule Name' }/></TableCell>
                                        <TableCell component="th" scope="row" sx={{ fontSize:"12px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)',paddingTop:"5px",paddingBottom:"5px"}}><CustomTableMetric children={ (currentalarmrule && Object.keys(currentalarmrule).length !==0 && currentalarmrule.hasOwnProperty('DeviceName') && currentalarmrule.DeviceName != undefined && currentalarmrule.hasOwnProperty('Alias') && currentalarmrule.Alias != undefined)? currentalarmrule?.DeviceName+":"+currentalarmrule?.Alias : "DeviceName:ParameterName"}/></TableCell>
                                        <TableCell component="th" scope="row" sx={{ fontSize:"12px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)',paddingTop:"5px",paddingBottom:"5px"}}><Button sx={{padding:"0px",fontSize:"16px",fontFamily:"Roboto",textTransform:'capitalize', backgroundColor:"var(--SecondaryBackground)", borderRadius:"20px", boxShadow: "none",paddingLeft:0}} variant="text" onClick={() => handleEdit(currentalarmrule)} disableTouchRipple elevation={0}><LK_Edit color={"#005C8E"} width={"17px"} height={"17px"}/></Button></TableCell>
                                        <TableCell component="th" scope="row" sx={{ fontSize:"12px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)',paddingTop:"5px",paddingBottom:"5px"}}><Button sx={{padding:"0px",fontSize:"16px",fontFamily:"Roboto",textTransform:'capitalize', backgroundColor:"var(--SecondaryBackground)", borderRadius:"20px", boxShadow: "none",paddingLeft:0}} variant="text" onClick={() => handleDelete(currentalarmrule)} disableTouchRipple elevation={0}><LK_Delete color={"#005C8E"} width={"25px"} height={"25px"}/></Button></TableCell>
                                        {/*<TableCell component="th" scope="row" sx={{ fontSize:"12px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)',paddingTop:"5px",paddingBottom:"5px"}}><Button sx={{padding:"0px",fontSize:"16px",fontFamily:"Roboto",textTransform:'capitalize', backgroundColor:"var(--SecondaryBackground)", borderRadius:"20px", boxShadow: "none",paddingLeft:0}} variant="text" onClick={() => handleClone(currentalarmrule)} disableTouchRipple elevation={0}><LK_Clone color={"#005C8E"} width={"25px"} height={"25px"}/></Button></TableCell> */}
                                        <Snackbar
                                            open={isCopied}
                                            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                                            sx={{height:"65px",border: '3px solid #FFFFFF', borderRadius: '150px',boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.5), 0 6px 20px 0 rgba(0, 0, 0, 0.5)'}}
                                            style={{ marginTop:`${(80)}px`, backgroundColor:"#005C8E" , color:"#FFFFFF" }}
                                            autoHideDuration={2000}
                                            onClose={() => setIsCopied(false)}
                                        >
                                            <Alert 
                                                icon={<ErrorOutlineOutlinedIcon fontSize="inherit" style={{height: '40px', width: '40px', color: '#FFFFFF'}}/>} 
                                                variant="filled"
                                                sx={{ width: '100%',borderRadius: '150px', backgroundColor:"#005C8E" , color: '#FFFFFF', '& .MuiAlert-icon': {color: '#FFFFFF'} }}
                                                style={{ display:'flex', alignItems:'center',alignContent: 'flex-start'}}
                                            >
                                                {"Alarm Rule Copied"} 
                                            </Alert>
                                        </Snackbar>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                <Dialogbox dialogtitle={"Confirm Deletion"} dialogtext={"Are you sure you want to delete this alarm rule?"} openDialog={openDialog} handleCloseDialog={handleCloseDialog} handleConfirmDialog={handleDeleteConfirm} themechange={themechange} confirmText={"Yes"} cancelText={"Cancel"}/>
                 <CustomDialogBox
                    dialogTitle={"Alert Rule Deletion"}
                    dialogText={deletedSuccessMsg}
                    openDialog={deletedSuccess}
                    handleCloseDialog={handlesetDeletedSuccess}
                    handleConfirmDialog={handlesetDeletedSuccess}
                    confirmText={"Ok"}
                    cancelText={"Cancel"}
                    type={"Success"}
                    />
                    
                    <CustomDialogBox
                    dialogTitle={"Alert Rule Deletion"}
                    dialogText={deletedErrorMsg}
                    openDialog={deletedError}
                    handleCloseDialog={handlesetDeletedError}
                    handleConfirmDialog={handlesetDeletedError}
                    confirmText={"Ok"}
                    cancelText={"Cancel"}
                    type={"Error"}
                    />{/*<Dialogbox dialogtitle={"Confirm Clone Rule"} dialogtext={"Are you sure you want to clone the rule?"} openDialog={open} handleCloseDialog={handleClose} handleConfirmDialog={handleCloneConditions} themechange={themechange} confirmText={"Confirm"} cancelText={"Cancel"}/>*/}
                {/*<Dialogbox dialogtitle={"Cloned Rule Exists"} dialogtext={"Clone Alarm Rule for same device's tag already exists"} openDialog={clonedRuleExists} handleCloseDialog={handleCloseClonedRuleExists} handleConfirmDialog={handleClonedRuleExists} themechange={themechange} confirmText={"Ok"} cancelText={"Close"}/>*/}
                </div>   
            </div> 
            : <></>
            }
            {(alarmrules == true && alarmrulesedit==false ) && <AlertRulesConfig setAlarmRules={setAlarmRules} alarmrulesclone={alarmrulesclone}/>}
            {(alarmrules == false && alarmrulesedit==true ) && <AlertRulesEdit setAlarmRulesEdit={setAlarmRulesEdit} uniquealarmcondition={uniquealarmcondition}/>}
            </div>}
        </>
    )

}